import { V2 } from '@eventr/common'
import { ColoursObj, Icon, TEventrIcons } from '@eventr/common-storybook'
import { HeaderV2 } from '../../../../common/headerV2'
import { renderComponents } from '../../../v2Utils'

interface IOriginalDTProps {
    data: V2
}

export const OriginalDT = ({ data }: IOriginalDTProps) => {
    return (
        <HeaderV2
            title={data.sectionDisplayName}
            iconElement={
                <Icon
                    name={
                        (data.rendererOptions?.settings
                            ?.headerIcon as TEventrIcons) ?? 'Activity'
                    }
                    iconColour={ColoursObj.core.primary}
                />
            }
        >
            {renderComponents(
                data.data,
                data.rendererOptions?.components ?? []
            )}
        </HeaderV2>
    )
}
